import type { ReactElement } from 'react';
import { Link } from 'react-router';

import { PageHeading } from '@/components/PageHeading';

export function NotFoundPage(): ReactElement {
  return (
    <>
      <PageHeading title="Seite nicht gefunden" />
      <Link className="text-sm underline underline-offset-4" to="/">
        Aktionen
      </Link>
    </>
  );
}
